// @core/api/endpoints/workflow/update_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineResponse,
  UpdatePipelineRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Update pipeline
 * Updates pipeline metadata: name, description, trigger type, error handling. Does not modify nodes/connections (use SaveDraft for that).
 */
export async function UpdatePipeline(
  pipeline_id: string,
  data: UpdatePipelineRequest,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.put<PipelineResponse>(requestPath, data, requestOptions);
}
